import mod from "-!./account.js?vue&type=script&lang=js&"; export default mod; export * from "-!./account.js?vue&type=script&lang=js&"